import GetNewsCategoryResponse from '../CRM/Responses/NewsCategoryResponse';

import Model from './Model';

export default class NewsCategory extends Model {
    readonly id: number;
    readonly name: string;
    readonly slug: string;
    readonly description: null | string;

    constructor(menu: Partial<GetNewsCategoryResponse>) {
        super();
        this.assignDataToProps(menu, ['id', 'name', 'slug', 'description']);
    }
}
